var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatemintDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5978_78192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 19.165C11.1253 19.165 12.2032 18.9621 13.1993 18.5911C12.9551 18.0696 12.8187 17.4876 12.8187 16.8737C12.8187 14.6342 14.6342 12.8187 16.8737 12.8187C17.4876 12.8187 18.0696 12.9551 18.5911 13.1993C18.9621 12.2032 19.165 11.1253 19.165 9.99996C19.165 4.93827 15.0617 0.834961 9.99996 0.834961C4.93827 0.834961 0.834961 4.93827 0.834961 9.99996C0.834961 15.0617 4.93827 19.165 9.99996 19.165ZM14.9874 17.6904C16.0666 16.989 16.989 16.0666 17.6904 14.9874C17.4401 14.8789 17.1639 14.8187 16.8737 14.8187C15.7388 14.8187 14.8187 15.7388 14.8187 16.8737C14.8187 17.1639 14.8789 17.4401 14.9874 17.6904ZM11.9479 4.61366C13.212 5.59102 13.3768 7.32757 12.3162 8.49233L10.0273 6.72267L8.34045 5.41837L9.03967 7.27924L10 9.83519C8.5428 10.3489 6.93145 9.62111 6.40106 8.20949C5.89384 6.8596 6.55879 5.37323 7.89229 4.79656C8.97378 3.7765 10.7428 3.6819 11.9479 4.61366ZM12.1077 15.2033C13.4412 14.6266 14.1062 13.1403 13.5989 11.7903C13.0686 10.3788 11.4573 9.65096 10 10.1647L10.9604 12.7207L11.6596 14.5816L9.97263 13.2772L7.68385 11.5076C6.62317 12.6723 6.78805 14.4089 8.05213 15.3862C9.25722 16.318 11.0263 16.2234 12.1077 15.2033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8738 14.5825C15.6083 14.5825 14.5825 15.6083 14.5825 16.8738C14.5825 18.1392 15.6083 19.165 16.8738 19.165C18.1392 19.165 19.165 18.1392 19.165 16.8738C19.165 15.6083 18.1392 14.5825 16.8738 14.5825Z",
    fill: "#E6007A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5978_78192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatemintDark);
export default __webpack_public_path__ + "static/media/statemint-dark.13f2912e1b33c3a6884485152a77462b.svg";
export { ForwardRef as ReactComponent };